// extracted by mini-css-extract-plugin
module.exports = {"klantenvertellen":"KlantenVertellen_klantenvertellen__UrVlS"};